import { render } from "./LinkChain.vue?vue&type=template&id=0040bdb8&scoped=true"
import script from "./LinkChain.vue?vue&type=script&lang=js"
export * from "./LinkChain.vue?vue&type=script&lang=js"

import "./LinkChain.vue?vue&type=style&index=0&id=0040bdb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0040bdb8"]])

export default __exports__